<template>
  <div :class="['action-panel__header p-2', { '--no-border': noBorder }]">
    <h3 class="my-0">
      <slot v-if="$slots.default" />
      <template v-else>
        {{ $t("components.modals.share.actionHeader.actions") }}
      </template>
    </h3>
  </div>
</template>

<script>
export default {
  props: {
    noBorder: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.action-panel__header {
  &:not(.--no-border) {
    margin-bottom: $size--2;
    border-bottom: 1px solid $color-ui--grey-10 !important;
  }
}
</style>
